function MessageRequest(){
    return (
        <>
            <div className="mssgrequest">
                <div >This is a Message Section</div>
                <div className="inputdivmessage">
                    <input className="inputmessage" placeholder="Type a Message"/>

                </div>
            </div>
        </>
    );
}
export default MessageRequest;